// Form validation for User form
import {
  emailValidator,
  nameValidator,
  phoneValidator,
  dropdownValidator,
  multiselectValidator,
  userValidator,
  plaintextValidator
} from '../fields';

const config = {};
const mandatoryConfig = { mandatory: true };

export default {
  firstName: nameValidator(mandatoryConfig),
  lastName: nameValidator(mandatoryConfig),
  email: emailValidator(mandatoryConfig),
  // phoneNumber: phoneValidator(mandatoryConfig),
  reportingManager: userValidator(config),
  'role.roleId': dropdownValidator(mandatoryConfig),
  'designation.designationId': dropdownValidator(config),
  'businessFunction.businessFunctionId': dropdownValidator(config),
  'team.teamId': dropdownValidator(config),
  clientList: {
    array: {
      'client.accountId': plaintextValidator(mandatoryConfig),
      'site.id': plaintextValidator(mandatoryConfig)
    }
  }
  // 'site.id': dropdownValidator({
  //   customError: 'Site should be selected',
  //   ...mandatoryConfig
  // })
};
